var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"elevation":"1"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.rateDetail},scopedSlots:_vm._u([{key:"item.direction",fn:function(ref){
var item = ref.item;
return _vm._l((item.direction),function(direction,i){return _c('span',{key:i},[_vm._v(_vm._s(direction))])})}}],null,true)}),_c('loading',{attrs:{"active":_vm.isLoading,"loader":_vm.loader}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }